import React from 'react';
import { ChevronLeft, Plus, Download, Sun, Moon, Globe, Clock } from 'lucide-react';
import Logo from '../Branding/Logo';

interface HeaderProps {
  language: string;
  isDarkMode: boolean;
  onNavigateLanding: () => void;
  onOpenLangPicker: () => void;
  onNewInvoice: () => void;
  onOpenHistory: () => void;
  onDownload: () => void;
  onToggleDarkMode: () => void;
}

const Header: React.FC<HeaderProps> = ({
  language,
  isDarkMode,
  onNavigateLanding,
  onOpenLangPicker,
  onNewInvoice,
  onOpenHistory,
  onDownload,
  onToggleDarkMode,
}) => {
  return (
    <header className="bg-white/80 dark:bg-slate-950/80 backdrop-blur-xl border-b border-slate-100 dark:border-slate-800 sticky top-0 z-50 no-print h-20">
      <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
        <div className="flex items-center gap-6">
          <button
            onClick={onNavigateLanding}
            className="p-2 text-slate-400 hover:text-brand-500 transition-all"
          >
            <ChevronLeft size={24} />
          </button>
          <div className="flex items-center gap-3 cursor-pointer group" onClick={onNavigateLanding}>
            <Logo size={40} className="group-hover:rotate-12 transition-transform duration-500" />
            <span className="font-black text-xl text-slate-900 dark:text-white hidden sm:block tracking-tighter">
              Invoice-Agent
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={onOpenLangPicker}
            className="hidden md:flex px-4 py-2 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-900 rounded-xl items-center gap-2 text-[10px] font-black uppercase tracking-widest border border-slate-200 dark:border-slate-800 transition-all"
          >
            <Globe size={14} className="text-brand-500" /> {language}
          </button>
          <button
            onClick={onOpenHistory}
            className="p-2.5 text-slate-400 hover:text-brand-500 hover:bg-slate-50 dark:hover:bg-slate-900 rounded-xl transition-all"
            title="Archive Vault"
          >
            <Clock size={22} />
          </button>
          <button
            onClick={onNewInvoice}
            className="p-2.5 text-slate-400 hover:text-brand-500 hover:bg-slate-50 dark:hover:bg-slate-900 rounded-xl transition-all"
            title="New Document"
          >
            <Plus size={22} />
          </button>
          <div className="h-6 w-px bg-slate-200 dark:bg-slate-800 mx-1"></div>
          <button
            onClick={onDownload}
            className="bg-brand-500 hover:bg-brand-600 text-white px-6 py-2.5 rounded-xl font-black text-xs flex items-center gap-2 shadow-lg shadow-brand-500/20 transition-all active:scale-95 uppercase tracking-wider"
          >
            <Download size={16} /> <span className="hidden lg:inline">Download PDF</span>
          </button>
          <button
            onClick={onToggleDarkMode}
            className="p-2.5 text-slate-400 hover:text-brand-500 transition-all"
          >
            {isDarkMode ? <Sun size={22} /> : <Moon size={22} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
